import { z } from 'zod'

export const DeliveryUnavailableSchema = z.object({
  errorResolutionType: z.literal('DELIVERY_UNAVAILABLE'),
  addressId: z.string().optional(),
})
